module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full bgdarkblue black",
    attrs: {
      "id": "space",
      "data-type": "layout"
    }
  }, [_c('canvas', {
    staticClass: "bgdarkblue",
    attrs: {
      "id": "starsCanvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-inner"
  }, [_c('h3', {
    staticClass: "pb6",
    domProps: {
      "innerHTML": _vm._s(_vm.page.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "planet-wrapper mt5 relative"
  }, [_c('div', {
    attrs: {
      "id": "stars"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "simple-fade"
    }
  }, [(_vm.isPopupActive) ? _c('div', {
    staticClass: "item-dialog item-dialog-single no-border pt2 pb2 content-500 bgblack",
    attrs: {
      "id": "planet-popup"
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.popupTitle))]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "entry-content"
  }, [_vm._v("\n              " + _vm._s(_vm.popupText) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "planet"
  }, [_c('div', {
    attrs: {
      "id": "planet-markers-container"
    }
  }, _vm._l((3), function(n) {
    return _c('div', {
      staticClass: "planet-markers"
    }, _vm._l((_vm.points), function(point, index) {
      return _c('a', {
        attrs: {
          "data-x": point.x,
          "data-y": point.y,
          "data-name": point.name,
          "data-text": point.text
        },
        on: {
          "click": function($event) {
            _vm.showPopup(index)
          }
        }
      })
    }))
  }))]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ovni"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "satellite"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cloud-wrapper"
  }, [_c('div', {
    staticClass: "cloud icon-cloud-right cloud-top-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-centred cloud-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-right cloud-middle-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-centred cloud-bottom-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud icon-cloud-left cloud-bottom-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "comets"
    }
  }, [_c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comet",
    attrs: {
      "id": "comet4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a7b56f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Problems-planet.vue
// module id = 165
// module chunks = 1